import React from "react";
import DOMPurify from "dompurify";
import { Paragraph } from "./Text";

const createMarkup = html => ({ __html: html.toString() });

const MarkText = ({ text, ...props }) => {

    return(
        <Paragraph color="currentColor" dangerouslySetInnerHTML={createMarkup(DOMPurify.sanitize(text, { ADD_ATTR: ['target'] }))} {...props} />
    );
};

export { MarkText };